import React, { useState } from 'react'
import { Button, Collapse, Box, TextField } from '@material-ui/core'

export default function ReasoningAccordion({ reasoning }) {
  const [expanded, setExpanded] = useState(false)

  if (!reasoning || reasoning === "undefined") {
    // Nothing to show if there's no reasoning text
    return null
  }

  const toggle = () => setExpanded(prev => !prev)

  return (
    <Box my={2}>
      <Button
        variant="outlined"
        color="primary"
        onClick={toggle}
      >
        {expanded ? 'Hide thinking' : 'Show thinking'}
      </Button>

      <Collapse in={expanded}>
        <Box mt={2}>
          <TextField
            variant="outlined"
            fullWidth
            multiline
            rows={20}
            value={reasoning}
            InputProps={{ readOnly: true }}
            style={{ fontFamily: 'monospace' }}
          />
        </Box>
      </Collapse>
    </Box>
  )
}
